import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Terminal, ArrowRight } from "lucide-react";

export default function Login() {
    const { login, error } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        const ok = await login(email, password);
        setBusy(false);
        if (ok) navigate("/app/tunnels");
    };

    return (
        <div className="min-h-screen bg-[#050505] flex">
            <div className="hidden lg:flex w-1/2 border-r border-[#27272A] flex-col p-12 justify-between relative overflow-hidden">
                <Link to="/" className="flex items-center gap-2" data-testid="login-logo">
                    <Terminal className="w-5 h-5 text-[#00FF41]" strokeWidth={2.5} />
                    <span className="font-display text-xl uppercase tracking-tight font-bold">SYNAPSELINK</span>
                </Link>
                <div className="space-y-3 max-w-md">
                    <div className="label-mono text-[#00FF41]">// auth/login</div>
                    <h1 className="heading-lg">WELCOME BACK,<br/>OPERATOR.</h1>
                    <p className="text-[#A1A1AA]">Your subdomains, keys, and live request streams are exactly where you left them.</p>
                </div>
                <pre className="text-[#52525B] text-xs leading-snug font-mono">{`▸ relay-iad-01     ............ ok
▸ relay-fra-04     ............ ok
▸ relay-syd-02     ............ ok
▸ tunnel session   ........ ready
▸ inspector socket .... attached`}</pre>
            </div>

            <div className="flex-1 flex items-center justify-center px-6">
                <div className="w-full max-w-md">
                    <div className="label-mono text-[#00FF41] mb-3">// SIGN IN</div>
                    <h2 className="heading-md mb-8">AUTHENTICATE TO CONTINUE_</h2>
                    <form onSubmit={submit} className="space-y-7" data-testid="login-form">
                        <div className="relative">
                            <span className="absolute left-0 top-2.5 text-[#52525B]">{">"}</span>
                            <input className="tf-input" placeholder="email@example.com" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
                            <div className="label-mono mt-1">EMAIL</div>
                        </div>
                        <div className="relative">
                            <span className="absolute left-0 top-2.5 text-[#52525B]">{">"}</span>
                            <input className="tf-input" placeholder="••••••••••" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
                            <div className="label-mono mt-1">PASSWORD</div>
                        </div>
                        {error && <div className="text-[#FF3B30] text-sm font-mono" data-testid="login-error">[ ERR ] {error}</div>}
                        <button disabled={busy} className="tf-btn w-full justify-center" data-testid="login-submit-btn">
                            {busy ? "AUTHENTICATING..." : "LOGIN"} <ArrowRight className="w-4 h-4" />
                        </button>
                    </form>
                    <div className="mt-8 text-sm text-[#A1A1AA]">
                        New here? <Link to="/register" className="text-[#00FF41] hover:underline" data-testid="login-to-register-link">Create an account →</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
